webpackJsonp([184662623972074],{

/***/ 396:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"html":"","frontmatter":{"name":"Holzauge Fotografie","address":"Schloßstraße 6, 50226 Frechen","mail":"info@holzauge-fotografie.de","phone":"015233589432"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---contact-4294b375cb49c3ef0333.js